import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import Login from '@/views/Login'
import i18n  from '../locales/i18n'
import superuserRoutes from "@/router/superuser";
import adminRoutes from "@/router/admin";
import shadowRoutes from "@/router/shadow";
import { setLanguage } from '@/utils/language-utils';

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location)
    .catch(err => {
      if (err.name != "NavigationDuplicated") {
        throw err;
      }
    })
};

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isLoggedIn) {
    next()
    return
  }

  next('/');
}


const routes = [
  // ====== LOGIN ======
  {
    path: '/:lang/login', 
    component: Login,
    beforeEnter: (to, from, next) => {
      const lang = to.params.lang;

      if(['en', 'gr', 'es'].includes(lang)) {
        i18n.locale = lang;
        setLanguage(lang); // <== Αποθήκευση στο localStorage

      }else {
        i18n.locale = 'en';
      }
      
      ifNotAuthenticated(to, from, next);

    }

  },
  // ====== SUPER USER ======
  ...superuserRoutes,
  // ====== ADMIN ======
  ...adminRoutes,
  ...shadowRoutes,
  {
    path: "*",
    redirect: to => {
      if (store.getters.isLoggedIn) {
        if (store.state.auth.role == 'admin') {
          return '/'
        } else {
          return '/superuser'
        }
      } else {
        return  `/${i18n.locale}/login`;
      }

    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
